module.exports = __webpack_public_path__ + "static/media/payme.3a4251bf.png";